import { lazy, Suspense, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import type { PageKind } from '../shared/types';
import { api } from './api';

const AdminPage = lazy(() =>
  import('./pages/AdminPage').then((module) => ({ default: module.AdminPage })),
);
const ListenerPage = lazy(() =>
  import('./pages/ListenerPage').then((module) => ({ default: module.ListenerPage })),
);
const TranslatorPage = lazy(() =>
  import('./pages/TranslatorPage').then((module) => ({ default: module.TranslatorPage })),
);

export function App() {
  useEffect(() => {
    if (pageViewTracked) return;
    pageViewTracked = true;
    void api.trackMetric({ kind: 'pageview', page: currentPage() }).catch(() => undefined);
  }, []);
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            minHeight: "100vh",
            display: "grid",
            placeItems: 'center'
          }}>
          <CircularProgress />
        </Box>
      }
    >
      {window.location.pathname.startsWith('/admin') ? (
        <AdminPage />
      ) : window.location.pathname.startsWith('/translate/') ? (
        <TranslatorPage />
      ) : (
        <ListenerPage />
      )}
    </Suspense>
  );
}

let pageViewTracked = false;

function currentPage(): PageKind {
  if (window.location.pathname.startsWith('/admin')) return 'admin';
  if (window.location.pathname.startsWith('/translate/')) return 'translator';
  return 'listener';
}
